module.exports = __webpack_public_path__ + "img/case-lg-2.e3c47a43.jpg";